import EditFormativeDialog from 'components/StudentSubmissions/EditFormativeDialog';
import UploadSubmissionDialog from 'components/StudentSubmissions/UploadSubmissionDialog';
import ViewFormativeDialog from 'components/StudentSubmissions/ViewFormativeDialog';
import { useApp } from 'contexts/app';
import { useAuth } from 'contexts/auth';
import { useViewport } from 'contexts/viewport';
import ErrorPage from 'pages/Error/404';
import Desktop from 'pages/StudentSubmissions/desktop';
import Mobile from 'pages/StudentSubmissions/mobile';
import { PageContext } from 'pages/StudentSubmissions/PageProvider';
import Tablet from 'pages/StudentSubmissions/tablet';
import { useContext } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { Loading } from 'shell/components';

const PageLayout = () => {
    const { isLoading, assignments, currentAssignment, studentSubmissions } = useApp();
    const { auth } = useAuth();
    const location = useLocation();
    const { device } = useViewport();

    const contextProps = useContext(PageContext);

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...contextProps} />,
            tablet: <Tablet {...contextProps} />,
            desktop: <Desktop {...contextProps} />,
        }[device];
    };

    const currentParams = new URLSearchParams(location.search);

    const expectedParams = new URLSearchParams({
        owner_account_id: auth.id,
        type: 'formative',
    });

    currentParams.sort();
    expectedParams.sort();

    const areParamsCorrect = currentParams.toString() === expectedParams.toString();

    if (isLoading || !studentSubmissions) return <Loading />;

    if (!areParamsCorrect && auth.id) return <Redirect to={`${location.pathname}?${expectedParams.toString()}`} />;

    if (assignments && !currentAssignment) return <ErrorPage />;

    return (
        <>
            {renderResponsiveLayout(device)}
            <UploadSubmissionDialog
                open={contextProps.uploadSubmissionDialog.open}
                assignment={currentAssignment}
                onClose={() => contextProps.setUploadSubmissionDialog({ open: false })}
                onClick={contextProps.createSubmissions}
            />
            <EditFormativeDialog
                open={contextProps.editFormativeDialog.open}
                onClose={() => contextProps.setEditFormativeDialog({ open: false })}
            />
            <ViewFormativeDialog
                dialog={contextProps.viewFormativeDialog}
                onClose={() => {
                    contextProps.setViewFormativeDialog((current) => ({ ...current, open: false }));
                    setTimeout(() => {
                        contextProps.setViewFormativeDialog((current) => ({ ...current, submissionId: '' }));
                    }, 150);
                }}
            />
        </>
    );
};

export default PageLayout;
